module.exports = __webpack_public_path__ + "img/new-table.6df09d8c.png";